(function () {
  if (window.customElements.get('rt-reviews-slider')) return;
  var AUTO_SETTLE = 150;  // ms of scroll silence that means a programmatic scroll has finished

  window.customElements.define('rt-reviews-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rt-reviews__track');
      const originals = Array.from(this.querySelectorAll('.rt-reviews__slide'));
      this.realCount = originals.length;
      if (!this.track || this.realCount < 2) return;

      // Clone only the neighbours the loop needs (C each side), not the whole set: enough to fill
      // half the widest viewport this screen can have + 2 for the scroll that runs before the
      // at-rest re-centre. Layout: [last C | originals | first C].
      const mkClone = (slide) => {
        const c = slide.cloneNode(true);
        c.classList.add('rt-reviews__slide--clone');
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('id');
        Array.from(c.attributes).forEach((a) => { if (a.name.indexOf('data-shopify') === 0) c.removeAttribute(a.name); });
        // os clones estao fora do ecra ate o carrossel rodar — 'lazy' e nao 'eager'.
        c.querySelectorAll('img').forEach((img) => { img.loading = 'lazy'; });
        return c;
      };
      const cs = getComputedStyle(this.track);
      // passo VISUAL: os laterais aparecem a sideScale*w + gap (ver _scale), mais cards por ecra que o layout
      const gap0 = parseFloat(this.dataset.gap);
      const ss0 = Math.min(1, (parseFloat(this.dataset.sideScale) || 100) / 100);
      const step = ss0 * originals[0].getBoundingClientRect().width + (Number.isFinite(gap0) ? gap0 : (parseFloat(cs.columnGap) || 0));
      const vw = Math.max(window.innerWidth, (window.screen && window.screen.width) || 0);
      this.clones = Math.min(this.realCount, Math.max(4, step > 0 ? Math.ceil(vw / 2 / step) + 2 : 4));
      const firstReal = originals[0];
      originals.slice(-this.clones).forEach((s) => this.track.insertBefore(mkClone(s), firstReal)); // last C, in order
      originals.slice(0, this.clones).forEach((s) => this.track.appendChild(mkClone(s)));            // first C

      this.slides = Array.from(this.querySelectorAll('.rt-reviews__slide'));
      this.dotsHost = this.querySelector('.rt-reviews__dots');
      this.prevBtn = this.querySelector('.rt-reviews__arrow--prev');
      this.nextBtn = this.querySelector('.rt-reviews__arrow--next');
      this.delay = parseInt(this.dataset.autoplay, 10) || 4000;
      // pausa depois de um swipe/toque e escala dos cards laterais vem da seccao
      // (Theme Editor).
      this.resume = (parseFloat(this.dataset.resume) || 2) * 1000;
      this.sideScale = Math.min(1, (parseFloat(this.dataset.sideScale) || 100) / 100);
      this.gap = parseFloat(this.dataset.gap);
      this._auto = false;      // true while a programmatic smooth scroll is animating
      this._suppress = false;  // true during our own instant scroll writes (jumps / re-centre)
      this._raf = 0;
      this._inView = true;

      if (this.dotsHost) this._buildDots();
      this._bindEvents();
      this._remeasure();       // measure + position the first real card centred (middle copy)
      this._setActive();

      // Layout/images may not be settled at connect — recompute (and keep the card centred) when they are.
      window.addEventListener('load', () => this._remeasure(), { once: true });
      if (window.ResizeObserver) {
        this._ro = new ResizeObserver(() => this._remeasure());
        this._ro.observe(this.track);
      }
      // autoplay só com o carrossel no ecrã e o separador visível
      if (window.IntersectionObserver) {
        this._io = new IntersectionObserver((entries) => { this._inView = entries[entries.length - 1].isIntersecting; });
        this._io.observe(this);
      }

      this._startAuto();
    }

    disconnectedCallback() {
      this._stopAuto();
      clearTimeout(this._idleTimer);
      clearTimeout(this._autoSettle);
      if (this._raf) cancelAnimationFrame(this._raf);
      if (this._ro) this._ro.disconnect();
      if (this._io) this._io.disconnect();
    }

    // scrollLeft is the single source of truth. base = scrollLeft that centres slide 0;
    // every centred snap point is base + i*stride. midLow = scrollLeft centring the first REAL card
    // (DOM index this.clones). Slide centres are cached here for _scale (offsetLeft ignores transforms).
    _measure() {
      const cw = this.track.clientWidth;
      const w0 = this.slides[0].offsetWidth;
      const C = this.clones;
      this.base = this.slides[0].offsetLeft - (cw - w0) / 2;
      this.realW = this.slides[C + this.realCount].offsetLeft - this.slides[C].offsetLeft; // one full set
      this.stride = this.realW / this.realCount;
      this.midLow = this.base + C * this.stride;
      this._w = w0;
      this._c = this.slides.map((s) => s.offsetLeft + s.offsetWidth / 2);
      // cards visible each side + 1, pelo passo VISUAL (laterais escalados), o mesmo G do _scale
      const vstep = Math.min(this.stride, this.sideScale * w0 + (Number.isFinite(this.gap) ? this.gap : this.stride - w0));
      this._span = vstep > 0 ? Math.ceil(cw / 2 / vstep) + 1 : this.slides.length;
    }
    // Recompute metrics and keep the currently-centred card centred (used at init + load + resize).
    _remeasure() {
      const prev = this.stride ? Math.round((this.track.scrollLeft - this.base) / this.stride) : this.clones;
      this._measure();
      this._suppress = true;
      this.track.scrollLeft = this.base + prev * this.stride;
      requestAnimationFrame(() => { this._suppress = false; this._recenterIfNeeded(); this._scale(); });
    }

    // o card do centro a 100% e os outros a `sideScale`, interpolado pela
    // distancia ao centro — cresce/encolhe continuamente enquanto o card anda (corre em cada
    // frame de scroll, que o scroll suave e o dedo disparam). transform nao mexe no layout,
    // por isso o snap e as contas de stride continuam iguais.
    //
    // gaps iguais em todos os cards: encolher cada card em torno do SEU centro deixa o que ele
    // perde como buraco dos dois lados, maior entre os laterais do que junto ao centro. Por isso
    // cada card tambem se
    // DESLOCA (translateX) para o gap visivel ser SEMPRE `this.gap` (setting "Gap between cards"),
    // parado ou a meio do scroll: fixa-se o gap entre os dois cards que ladeiam o meio (o centro
    // desse gap anda linear com o scroll) e encadeiam-se os outros a partir deles.
    // So se escrevem os cards a _span do centro (os visiveis + 1); os outros estao fora do ecra.
    _scale() {
      if (!this.stride || this.sideScale >= 1 || !this._c) return;
      const mid = this.track.scrollLeft + this.track.clientWidth / 2;
      const k = 1 - this.sideScale;
      const S = this.stride;
      const n = this.slides.length;
      if (n < 2) return;
      const w = this._w;
      const G = Number.isFinite(this.gap) ? this.gap : S - w;
      const c = this._c;
      const v = c.map((x) => 1 - k * Math.min(1, Math.abs(x - mid) / S));
      let j = 0;
      while (j < n - 2 && c[j + 1] <= mid) j++;
      const centroGap = mid + ((c[j] + c[j + 1]) / 2 - mid) * (w + G) / S;
      const V = new Array(n);
      V[j] = centroGap - G / 2 - v[j] * w / 2;
      V[j + 1] = centroGap + G / 2 + v[j + 1] * w / 2;
      for (let i = j - 1; i >= 0; i--) V[i] = V[i + 1] - (v[i] + v[i + 1]) * w / 2 - G;
      for (let i = j + 2; i < n; i++) V[i] = V[i - 1] + (v[i - 1] + v[i]) * w / 2 + G;
      const lo = Math.max(0, j - this._span), hi = Math.min(n - 1, j + 1 + this._span);
      // o transform vai no card de DENTRO do <li>: o snap mede a caixa transformada, e com ele no <li>
      // o scroll suave parava ~16px antes do centro (o alvo era o card ainda encolhido).
      for (let i = lo; i <= hi; i++) {
        const s = this.slides[i].firstElementChild || this.slides[i];
        const tr = 'translateX(' + (V[i] - c[i]).toFixed(2) + 'px) scale(' + v[i].toFixed(4) + ')';
        if (s._rtTransform !== tr) { s._rtTransform = tr; s.style.transform = tr; }
      }
    }

    _buildDots() {
      this.dots = [];
      for (let i = 0; i < this.realCount; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'rt-reviews__dot';
        b.setAttribute('aria-label', (this.dataset.dotLabel || '[n]').replace('[n]', i + 1));
        b.addEventListener('click', () => { this._goto(i); this._onUserActivity(); });
        this.dotsHost.appendChild(b);
        this.dots.push(b);
      }
    }

    _index() { return this.stride ? Math.round((this.track.scrollLeft - this.base) / this.stride) : this.clones; }
    _activeIndex() {
      const i = (this._index() - this.clones) % this.realCount;
      return (i + this.realCount) % this.realCount;
    }
    _setActive() {
      if (!this.dots) return;
      const a = this._activeIndex();
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === a));
    }

    // Instant, pixel-identical jump by one set to stay in the middle copy. Safe only when at rest.
    _recenterIfNeeded() {
      if (!this.realW) return;
      const sl = this.track.scrollLeft;
      let to = null;
      if (sl >= this.midLow + this.realW - 1) to = sl - this.realW;
      else if (sl < this.midLow - 1) to = sl + this.realW;
      if (to === null) return;
      this._suppress = true;
      const snap = this.track.style.scrollSnapType;
      this.track.style.scrollSnapType = 'none';
      this.track.scrollLeft = to;
      requestAnimationFrame(() => { this.track.style.scrollSnapType = snap; this._suppress = false; });
    }

    _onScroll() {
      if (this._suppress) { /* our own jump — ignore */ }
      else if (this._auto) { this._armSettle(); }   // programmatic scroll still settling
      else { this._onUserActivity(); }              // real user scroll resets the idle countdown
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = 0;
        if (!this._auto && !this._suppress && !this._drag) this._recenterIfNeeded(); // recenter at rest, never mid-animation or mid-drag
        this._scale();
        this._setActive();
      });
    }
    _armSettle() {
      clearTimeout(this._autoSettle);
      this._autoSettle = setTimeout(() => {
        this._auto = false;
        this._recenterIfNeeded(); // animation finished; do the invisible wrap now, at rest
      }, AUTO_SETTLE);
    }

    _scrollSmooth(left) {
      this._auto = true;
      this._armSettle();
      this.track.scrollTo({ left: left, behavior: 'smooth' });
    }
    _tick() {
      if (!this.stride) return;
      this._scrollSmooth(this.base + (this._index() + 1) * this.stride);
    }
    _goto(i) {
      if (!this.stride) return;
      // centred position of real card i within the middle copy
      this._scrollSmooth(this.midLow + (i % this.realCount) * this.stride);
    }
    _next() { this._tick(); }
    _prev() {
      if (!this.stride) return;
      this._scrollSmooth(this.base + (this._index() - 1) * this.stride);
    }

    _startAuto() {
      this._stopAuto();
      this.timer = setInterval(() => { if (this._inView && !document.hidden) this._tick(); }, this.delay);
    }
    _stopAuto() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    _scheduleResume() {
      clearTimeout(this._idleTimer);
      this._idleTimer = setTimeout(() => this._startAuto(), this.resume);
    }
    _onUserActivity() { this._stopAuto(); this._scheduleResume(); }

    // arrastar com o RATO (como a fila de avis da PDP). O dedo
    // continua no scroll nativo. Durante o arrasto o track segue o cursor 1:1 sem snap; ao largar
    // projecta-se a velocidade (~250 ms de inercia) e desliza-se suave ate ao card mais proximo
    // desse ponto. O preventDefault no pointerdown e o que tira o "arrastar a foto" nativo.
    _bindMouseDrag() {
      const t = this.track;
      let d = null;
      t.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || !this.stride) return;
        e.preventDefault();
        clearTimeout(this._autoSettle);
        this._auto = false;
        this._onUserActivity();
        d = { x: e.clientX, left: t.scrollLeft, lastX: e.clientX, lastT: e.timeStamp, v: 0, moved: false, id: e.pointerId };
      });
      t.addEventListener('pointermove', (e) => {
        if (!d || e.pointerId !== d.id) return;
        const dx = e.clientX - d.x;
        if (!d.moved) {
          if (Math.abs(dx) < 4) return;
          d.moved = true;
          this._drag = true;
          this._snap = t.style.scrollSnapType;
          t.style.scrollSnapType = 'none';
          t.style.scrollBehavior = 'auto';
          t.classList.add('is-dragging');
          try { t.setPointerCapture(e.pointerId); } catch (err) {}
        }
        const dt = e.timeStamp - d.lastT;
        if (dt > 0) d.v = d.v * 0.3 + ((e.clientX - d.lastX) / dt) * 0.7;
        d.lastX = e.clientX; d.lastT = e.timeStamp;
        t.scrollLeft = d.left - dx;
      });
      const end = (e) => {
        if (!d || e.pointerId !== d.id) return;
        const wasDrag = d.moved;
        const v = (e.timeStamp - d.lastT < 80) ? d.v : 0;
        d = null;
        if (!wasDrag) return;
        t.classList.remove('is-dragging');
        t.style.scrollSnapType = this._snap || '';
        t.style.scrollBehavior = '';
        this._drag = false;
        this._justDragged = true;
        setTimeout(() => { this._justDragged = false; }, 0);
        const target = t.scrollLeft - v * 250;
        const i = Math.round((target - this.base) / this.stride);
        this._scrollSmooth(this.base + i * this.stride);
        this._onUserActivity();
      };
      t.addEventListener('pointerup', end);
      t.addEventListener('pointercancel', end);
      // um arrasto nao conta como clique num link/foto do card
      t.addEventListener('click', (e) => { if (this._justDragged) { e.preventDefault(); e.stopPropagation(); } }, true);
    }

    _bindEvents() {
      this.track.addEventListener('scroll', () => this._onScroll(), { passive: true });
      ['pointerdown', 'touchstart', 'wheel'].forEach((e) =>
        this.addEventListener(e, () => this._onUserActivity(), { passive: true }));
      if (window.matchMedia && window.matchMedia('(hover:hover)').matches) {
        this.addEventListener('mouseenter', () => { this._stopAuto(); clearTimeout(this._idleTimer); });
        this.addEventListener('mouseleave', () => this._scheduleResume());
      }
      this.addEventListener('focusin', () => this._onUserActivity());
      this.addEventListener('focusout', () => this._scheduleResume());
      this._bindMouseDrag();
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this._prev(); this._onUserActivity(); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this._next(); this._onUserActivity(); });
    }
  });
})();
